/* eslint-disable new-cap */
/* eslint-disable no-undef */
/* eslint-disable no-new */
(function () {
  const popUpElement = document.querySelector(`.pop-up-block`);

  const forms = popUpElement.querySelectorAll(`form`);

  Array
    .from(forms)
    .forEach((form) => {
      const params = {
        fields: {
          phone: `* p`
        }
      };

      if (form.querySelector(`input[name="email"]`)) {
        params.fields.email = {
          rules: `* @`,
          timeout: 500
        };
      }

      new tFormer(form.id, params);
    });
})();
